import styled from 'styled-components'

type PinnableTooltipProps = {
  /** Held open by a click on its trigger, whatever the pointer and focus do. */
  $pinned?: boolean
}

/**
 * A tooltip that opens with plain CSS and needs no timers. It is a child of
 * `PinnableTooltipAnchor` together with its trigger, so moving the pointer
 * from the trigger into the tooltip never leaves the anchor and the tooltip
 * stays open on its way to a button inside it; keyboard focus anywhere in
 * the anchor opens it too, and `$pinned` keeps it open. Each surface extends
 * it with its own position and look (`styled(PinnableTooltip)`).
 */
export const PinnableTooltip = styled.div<PinnableTooltipProps>`
  display: ${({ $pinned }) => ($pinned ? 'block' : 'none')};
  position: absolute;
`

/**
 * The element that holds a `PinnableTooltip` and its trigger: hovering
 * anywhere inside it, or focusing a control inside it, shows the tooltip.
 * Each surface extends it with its own placement.
 */
export const PinnableTooltipAnchor = styled.div`
  &:hover ${PinnableTooltip}, &:focus-within ${PinnableTooltip} {
    display: block;
  }
`
